import { ShieldCheck, Clock4, HeartHandshake, Award } from "lucide-react";

const ABOUT_IMG = "/brand/pods-load.jpg";
const PACK_IMG = "https://images.pexels.com/photos/7203701/pexels-photo-7203701.jpeg";

const reasons = [
  { icon: ShieldCheck, title: "Care You Can Count On", desc: "Every move handled with the attention a family business brings — your stuff treated like it's ours." },
  { icon: Clock4, title: "On-Time, Every Time", desc: "98% of moves arrive in the scheduled window — or we discount the bill." },
  { icon: HeartHandshake, title: "Family-Run, Local Crew", desc: "No day-laborers. No subcontractors. Just our team, in our trucks." },
  { icon: Award, title: "4.9★ on Google", desc: "From 600+ verified reviews. Real customers, real moves." },
];

export default function About() {
  return (
    <section id="about" className="py-24 lg:py-32" data-testid="about-section">
      <div className="mx-auto max-w-7xl px-5 lg:px-8 grid lg:grid-cols-2 gap-16 items-start">
        <div className="grid grid-cols-2 gap-4">
          <img src={ABOUT_IMG} alt="ThemBoys crew at moving van" className="w-full aspect-[3/4] object-cover" />
          <div className="space-y-4 pt-12">
            <img src={PACK_IMG} alt="Carefully stacked boxes" className="w-full aspect-square object-cover" />
            <div className="bg-[#223932] text-white p-6">
              <div className="font-mono-label text-[10px] text-[#5BB239]">Since 2019</div>
              <div className="mt-2 font-display font-black text-4xl tracking-tight">2,400+</div>
              <div className="mt-1 text-xs text-white/60">Successful moves & counting</div>
            </div>
          </div>
        </div>
        <div>
          <div className="overline">Why ThemBoys</div>
          <h2 className="mt-3 font-display font-black text-4xl sm:text-5xl lg:text-6xl tracking-tight leading-[0.95]">
            Not your<br />average movers.
          </h2>
          <p className="mt-6 text-[#5C635F] leading-relaxed max-w-lg">
            We started out helping neighbors move couches in Louisville. Six years later, we're
            the moving crew Kentucky calls when the move <em>has</em> to go right — and we
            serve customers across all 50 states.
          </p>

          <div className="mt-10 grid sm:grid-cols-2 gap-6">
            {reasons.map((r) => (
              <div key={r.title} className="border-t-2 border-[#5BB239] pt-4">
                <r.icon className="w-5 h-5 text-[#223932]" />
                <h3 className="mt-3 font-display font-bold text-lg">{r.title}</h3>
                <p className="mt-1 text-sm text-[#5C635F] leading-relaxed">{r.desc}</p>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
